import { render } from "./CommandCell.vue?vue&type=template&id=c810344c&scoped=true"
import script from "./CommandCell.vue?vue&type=script&lang=js"
export * from "./CommandCell.vue?vue&type=script&lang=js"

import "./CommandCell.vue?vue&type=style&index=0&id=c810344c&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\eNotary.SPA\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c810344c"]])

export default __exports__